import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SplitLines } from "@/components/Reveal";
import { MANIFESTO, BRAND } from "@/lib/site";

export const Manifesto = () => (
  <section id="about" data-testid="about-section" className="relative bg-[var(--bg)] py-28 lg:py-40">
    <div className="container-x grid gap-16 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal><p className="eyebrow mb-6">Brand Story</p></Reveal>
        <SplitLines as="h2" inView className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.05] tracking-tight text-[var(--navy)]" lines={["Welcome to", <>Starke United <em className="italic text-[var(--mint)]">Global</em></>, "Resources LLP."]} />
        <Reveal delay={0.3}>
          <p className="mt-8 max-w-md text-base leading-relaxed text-[var(--muted)]">
            {BRAND.short} is a manufacturer and exporter of glazed vitrified tiles, built on one idea: a slab should look identical whether it is laid in Sydney, Dubai or São Paulo. Automated production, digital glaze printing and inline shade sorting make that promise possible.
          </p>
          <Link to="/#infrastructure" data-testid="about-discover-btn" className="btn-pill btn-ghost mt-8 text-xs">Discover our infrastructure <ArrowUpRight size={14} className="arrow" /></Link>
        </Reveal>
        <Reveal delay={0.4} className="relative mt-14 aspect-[4/3] overflow-hidden rounded-[1.5rem]">
          <img src="https://customer-assets-cm19k8pv.emergentagent.net/job_tile-showcase-55/artifacts/pslljyxm_WhatsApp%20Image%202026-09-20%20at%2015.47.31.jpeg" alt="Tile production line" className="h-full w-full object-cover" />
          <div className="absolute bottom-4 left-4 rounded-full glass px-3 py-1 font-mono text-[0.58rem] uppercase tracking-widest text-[var(--navy)]">Morbi · Gujarat</div>
        </Reveal>
      </div>

      <div className="lg:col-span-6 lg:col-start-7 lg:pt-24">
        {MANIFESTO.map((m, i) => (
          <motion.article
            key={m.n}
            data-testid={`manifesto-${m.n}`}
            initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-10% 0px" }} transition={{ duration: 0.9, delay: i * 0.1, ease: [0.2, 0.8, 0.2, 1] }}
            className="group relative grid grid-cols-[auto_1fr] gap-6 border-t border-slate-200 py-10 sm:gap-10"
          >
            <span className="font-display text-5xl font-light num-outline leading-none transition-colors duration-500 group-hover:text-[var(--mint)] sm:text-6xl">{m.n}</span>
            <div>
              <h3 className="font-display text-2xl font-medium tracking-tight text-[var(--navy)]">{m.title}</h3>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-[var(--muted)] sm:text-base">{m.text}</p>
            </div>
          </motion.article>
        ))}
        <div className="border-t border-slate-200" />
      </div>
    </div>
  </section>
);
